import { getApiBase } from './apiBase';

const AVATAR_HOME = '/';

export function redirectToAvatar() {
  if (typeof window !== 'undefined') {
    window.location.replace(AVATAR_HOME);
  }
}

export function isAdminIpDeniedResponse(res, data = {}) {
  return (
    res?.status === 403 &&
    (data?.code === 'ADMIN_IP_DENIED' ||
      String(data?.error || '').toLowerCase().includes('network'))
  );
}

/** Redirect to avatar when IP is not on ADMIN_ALLOWED_IPS. Returns true if redirected. */
export function redirectIfAdminIpDenied(res, data = {}) {
  if (isAdminIpDeniedResponse(res, data)) {
    redirectToAvatar();
    return true;
  }
  return false;
}

/**
 * Probe dashboard API; disallowed IPs are redirected to the avatar app.
 * Fail-open on network errors so a blip does not lock admins out.
 */
export async function probeAdminIpAllowed() {
  const base = getApiBase();
  try {
    const res = await fetch(`${base}/api/dashboard/ip-check`, { method: 'GET' });
    const data = await res.json().catch(() => ({}));
    if (redirectIfAdminIpDenied(res, data)) return false;
    return res.ok;
  } catch {
    return true;
  }
}
